<template>
  <div class="p-4">
    <div class="level">
      <div class="level-left">
        <h1 class="title is-5">Managers</h1>
      </div>

      <div class="level-right">
        <b-dropdown ref="addManagerDropdown" position="is-bottom-left">
          <button slot="trigger" class="button is-white">Add Manager</button>

          <form @submit.prevent="addManager" class="dropdown-item" style="width: 300px;">
            <b-field label="User">
              <user-select v-model="addManagerForm.user_id"></user-select>
            </b-field>

            <button
              class="button is-primary mr-2"
              :class="{'is-loading': addManagerForm.processing}"
            >Add</button>

            <button type="button" class="button is-white">Cancel</button>
          </form>
        </b-dropdown>
      </div>
    </div>

    <b-table :data="managers.data" :loading="managers.loading">
      <template slot-scope="{row: manager}">
        <b-table-column label="Name">{{ manager.name }}</b-table-column>

        <b-table-column label="Email">{{ manager.email }}</b-table-column>

        <b-table-column>
          <div class="is-pulled-right">
            <confirm-dialog
              :message="`Are you sure to remove ${manager.name} from the managers list?`"
              @confirmed="removeManager(manager)"
            >
              <button slot="trigger" class="button">
                <b-icon icon="close"></b-icon>
              </button>
            </confirm-dialog>
          </div>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>{{$tc('Nothinghere')}}</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import UserSelect from "@/modules/admin/components/selectors/UserSelect";

export default {
  components: {
    UserSelect
  },

  data() {
    return {
      managers: new window.RemoteCollection(this.baseUrl).load(),

      addManagerForm: new window.Form({
        user_id: null
      })
    };
  },

  methods: {
    baseUrl() {
      return `/admin/api/publishers/${this.$route.params.id}/managers`;
    },

    addManager() {
      this.addManagerForm.post(this.baseUrl()).then(this.whenAdded);
    },

    whenAdded(res) {
      this.managers.load();

      this.$buefy.toast.open(res.message);

      this.$refs.addManagerDropdown.toggle();
    },

    removeManager(manager) {
      this.$http
        .delete(`${this.baseUrl()}/${manager.id}`)
        .then(this.whenManagerRemoved);
    },

    whenManagerRemoved(res) {
      this.managers.load();

      this.$buefy.toast.open(res.data.message);
    }
  }
};
</script>
